import { createModel } from "hox";
import { IServiceItemsSearch, IServiceItemsParams, IServiceItemsDetail, IServiceItemsInsert, IServiceItemsUpdata, IServiceItemsDisable } from "./serviceItemsTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, findOption } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { serviceItemsService } from "./serviceItemsService"
import useMdmModel from "../../../model/mdmModel"
import moment, { Moment } from "moment";

export const useServiceItemsModel = createModel(function () {
    const initSearchParams: IServiceItemsParams = {}
    const initDataSource: IServiceItemsDetail[] = []
    const initAddParam: IServiceItemsInsert = {
        price: 0,
        workHours: 1,
        amount: 0,
        enable:true,
        branch:"main"
    }
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IServiceItemsParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IServiceItemsDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IServiceItemsDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<IServiceItemsInsert>(initAddParam);
    const upDataSearchParam = (upDataParam: IServiceItemsParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IServiceItemsParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await serviceItemsService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }
    const updataAddParam = (updateParam: IServiceItemsInsert) => {
        let newUpdateParam = updateParam
        if (Object.keys(updateParam)[0] === "price") {
            newUpdateParam = { ...updateParam, amount: updateParam.price * addParam.workHours, }
        }
        if (Object.keys(updateParam)[0] === "workHours") {
            newUpdateParam = { ...updateParam, amount: addParam.price * updateParam.workHours, }
        }
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: IServiceItemsDetail) => {
        let newUpdateParam = updateParam
        if (Object.keys(updateParam)[0] === "price") {
            newUpdateParam = { ...updateParam, amount: updateParam.price * selectedRow[0].workHours, }
        }
        if (Object.keys(updateParam)[0] === "workHours") {
            newUpdateParam = { ...updateParam, amount: selectedRow[0].price * updateParam.workHours, }
        }
        setSelectedRow([{ ...selectedRow[0], ...newUpdateParam }])
    }
    const insertDetail = async (params: IServiceItemsInsert) => {
        const param = {
            ...addParam,
            sourceApp: "mdm",
            enable: addParam.enable ? 1 : 0,
        }
        const { retData, retMsg } = await serviceItemsService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const updataDetail = async (params: IServiceItemsDetail) => {
        const param = {
            ...selectedRow[0],
            enable: selectedRow[0].enable ? 1 : 0,
        }
        const { retData, retMsg } = await serviceItemsService.update(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const cutDisabled = async (params: IServiceItemsDetail, checked: boolean) => {
        const param = {
            ...params,
            enable: checked ? 1 : 0,
        }
        const { retData, retMsg } = await serviceItemsService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        selectedRowKeys,
        addParam,
        setSearchParam,
        setDataSource,
        setPage,
        setSelectedRowKeys,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled
    }
});